export const PermissionsConstants = {
    ViewReclamations: 'ViewReclamations',
    ViewReserves: 'ViewReserves',
    ViewSubscriptions: 'ViewSubscriptions',
    ViewTransactions: 'ViewTransactions',
    ViewAdmin: 'ViewAdmin'
}